import {
    Button,
    Card,
    Col,
    Drawer,
    Form,
    Input,
    notification,
    Popconfirm,
    Tooltip
} from 'antd'
import _ from 'lodash'
import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { CustomCkEditor, InputBox } from '../../components/_utils/appUtils'

@Form.create()
class AddBlogInformation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            title: '',
            menuHeading: '',
            description: '',
            loading: false
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && (this.props.visible !== prevProps.visible || !_.isEqual(this.props.data, prevProps.data))) {
            if (this.props.data) {
                this.setState({
                    title: this.props.data.title || '',
                    menuHeading: this.props.data.menuHeading || '',
                    description: this.props.data.description || ''
                })
            } else if (!prevProps.data || prevProps.visible !== this.props.visible) {
                this.setState({
                    title: '',
                    menuHeading: '',
                    description: ''
                })
            }
        }
    }

    submitForm = () => {
        const { title, menuHeading, description } = this.state
        if (!title) {
            notification.warning({
                message: 'Enter Title.'
            })
            return
        }
        if (!menuHeading) {
            notification.warning({
                message: 'Enter Index Heading.'
            })
            return
        }
        if (!description) {
            notification.warning({
                message: 'Enter content.'
            })
            return
        }

        const isEdit = this.props.editIndex !== null

        if (!isEdit) {
            let existing = _.find(this.props.arrayData, item => {
                return item.title.toLowerCase() === title.toLowerCase()
            })
            if (existing !== undefined) {
                notification.error({ message: 'Title already exists, enter unique title.' })
                return
            }
        }

        const payload = {
            title,
            menuHeading,
            description
        }

        if (isEdit) {
            this.props.addDetails(payload, this.props.editIndex)
        } else {
            this.props.addDetails(payload)
        }

        this.setState({
            title: '',
            menuHeading: '',
            description: ''
        })

        if (isEdit) this.props.onClose()
    }

    render() {
        const { visible, onClose, editIndex, arrayData, editInfoRow, handleDelete } = this.props
        return (
            <>
                <Drawer
                    title={editIndex !== null ? 'Edit Blog Section' : 'Manage Blog Sections'}
                    width={'70%'}
                    visible={visible}
                    maskClosable={true}
                    placement='right'
                    onClose={onClose}>
                    <Card bordered={false} bodyStyle={{ padding: 20, background: '#fff' }}>
                        <Form hideRequiredMark className={'inputForm'}>
                            <Col span={24}>
                                <InputBox title={'Index Heading'}>
                                    <Input
                                        value={this.state.menuHeading}
                                        placeholder='Index Heading...'
                                        onChange={e => {
                                            this.setState({
                                                menuHeading: e.target.value
                                            })
                                        }}
                                    />
                                </InputBox>
                            </Col>
                            <Col span={24} style={{ marginTop: 15 }}>
                                <InputBox title={'Title'} required={true}>
                                    <Input
                                        value={this.state.title}
                                        placeholder='Title...'
                                        onChange={e => {
                                            this.setState({
                                                title: e.target.value
                                            })
                                        }}
                                    />
                                </InputBox>
                            </Col>

                            <Col span={24} style={{ marginTop: 20 }}>
                                <CustomCkEditor
                                    html={this.state.description}
                                    title={'Section Content'}
                                    height={300}
                                    onChange={value => {
                                        this.setState({
                                            description: value
                                        })
                                    }}
                                />
                            </Col>
                            <Col span={24} style={{ marginTop: 20 }}>
                                <Form.Item>
                                    <Button
                                        type='primary'
                                        style={{ background: '#000', borderColor: '#000' }}
                                        onClick={() => {
                                            this.submitForm()
                                        }}>
                                        {editIndex !== null ? 'Update' : 'Submit'}
                                    </Button>
                                    {editIndex !== null && (
                                        <Button style={{ marginLeft: 10 }} onClick={onClose}>
                                            Cancel
                                        </Button>
                                    )}
                                </Form.Item>
                            </Col>
                        </Form>
                    </Card>

                    <div style={{ marginTop: '20px', padding: '0 20px' }}>
                        {arrayData && arrayData.map((item, i) => (
                            <Card
                                key={i}
                                size="small"
                                style={{
                                    marginBottom: '15px',
                                    border: '1px solid #e8e8e8',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                }}
                                headStyle={{
                                    background: '#f5f5f5',
                                    borderBottom: '1px solid #e8e8e8',
                                    fontWeight: 'bold'
                                }}
                                title={`${item.title} (${item.menuHeading})`}
                                extra={
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <Tooltip title='Edit'>
                                            <Button
                                                size="small"
                                                icon='edit'
                                                style={{ border: 'none', background: 'transparent' }}
                                                onClick={() => editInfoRow(item, i)}
                                            />
                                        </Tooltip>
                                        <Popconfirm
                                            title='Sure to delete?'
                                            onConfirm={() => handleDelete(item.title)}
                                            okText='Yes'
                                            cancelText='No'
                                        >
                                            <Button
                                                size="small"
                                                icon='delete'
                                                style={{ border: 'none', background: 'transparent' }}
                                            />
                                        </Popconfirm>
                                    </div>
                                }
                            >
                                <div style={{ fontSize: '13px', color: '#555', padding: '4px 0' }}>
                                    {ReactHtmlParser(item.description)}
                                </div>
                            </Card>
                        ))}
                    </div>
                </Drawer>
            </>
        )
    }
}

export default AddBlogInformation
